// extracted by mini-css-extract-plugin
export default {"setting":"Setting_setting__tZJmd"};